import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { DocumentVersionsTable } from "./DocumentVersionsTable";
import { FileRecordDocumentsSidebar } from "./FileRecordDocumentsSidebar";
import { Alert } from "../../../../theme/Component/Alert";

interface DocumentFileManagerContentProps {
    fileRecordId: number;
    fileRecordName?: string;
    onBackToRecords?: () => void;
}

export const DocumentFileManagerContent = ({ fileRecordId, fileRecordName, onBackToRecords }: DocumentFileManagerContentProps) => {
    const [selectedFileRecordDocumentId, setSelectedFileRecordDocumentId] = useState<number | null>(null);
    const [selectedRepositoryName, setSelectedRepositoryName] = useState("");
    const [selectedFileRecordDocument, setSelectedFileRecordDocument] = useState<Record<string, any> | null>(null);

    useEffect(() => {
        setSelectedFileRecordDocumentId(null);
        setSelectedRepositoryName("");
        setSelectedFileRecordDocument(null);
    }, [fileRecordId]);

    const selectFileRecordDocument = (
        fileRecordDocumentId: number | null,
        repositoryName = "",
        fileRecordDocument: Record<string, any> | null = null,
    ) => {
        setSelectedFileRecordDocumentId(fileRecordDocumentId);
        setSelectedRepositoryName(repositoryName);
        setSelectedFileRecordDocument(fileRecordDocument);
    };

    return (
        <>
            <div className="document-file-manager__toolbar">
                <div className="document-file-manager__toolbar-title">
                    {onBackToRecords &&
                        <div className="document-file-manager__back-action">
                            <BasicButton icon="ri-arrow-left-line" eventClick={onBackToRecords} clase="light" timeStopClickSeg={250}>
                                Volver
                            </BasicButton>
                        </div>
                    }

                    <h1 className="document-file-manager__heading">
                        {fileRecordName ? `Expediente: ${fileRecordName}` : "Expediente"}
                    </h1>
                </div>
            </div>

            <div className="document-file-manager__detail-layout">
                <FileRecordDocumentsSidebar
                    fileRecordId={fileRecordId}
                    selectedFileRecordDocumentId={selectedFileRecordDocumentId}
                    onSelectFileRecordDocument={selectFileRecordDocument}
                />

                <div className="document-file-manager__detail-main">
                    {selectedFileRecordDocumentId ?
                        <DocumentVersionsTable
                            fileRecordId={fileRecordId}
                            fileRecordDocumentId={selectedFileRecordDocumentId}
                            fileRecordDocument={selectedFileRecordDocument}
                            repositoryName={selectedRepositoryName}
                        />:
                        <Alert children={"Debe Seleccionar un Repositorio"} clase="info" />
                        }
                </div>
            </div>
            
        </>
    );
};
